import { string, object, array, number, date } from "yup"
import { ID2 } from "./yup.common"

export default object({
  userId: ID2("User").required("Please select a valid user"),
  orderItems: array(
    object({
      sellableItemStockId: ID2("Sellable Item Stock").required(
        "Please enter a valid sellable item stock!"
      ),
      quantity: number()
        .min(1, "Quantity should be greater than 0")
        .required("Please enter a valid item quantity"),
    })
  ).min(1, "Please select atleast 1 order item"),
  pickupSlots: array(
    object({
      distributionCentreId: ID2("Distribution Center").required(
        "Please enter a distribution center"
      ),
      timeSlotId: ID2("Time Slot").required("Please enter a valid time slot!"),
    })
  ),
  shippingMethod: string().required("Please select a shipping method!"),
})

export const consolidatedOrder = object({
  date: date().required("Please enter a valid date!"),
  id: ID2("Order ID"),
  orderFilter: object(),
  orderIds: array(ID2("Orders")).min(1),
  orderingDcId: ID2("Source DC").required("Please enter a valid source DC"),
  targetDcId: ID2("Target DC").required("Please enter a valid target DC"),
  remark: string(),
  shopId: ID2("Shop ID"),
  placedInId: ID2("Department").required(
    "Please ensure that a current department is set to the logged in user!"
  ),
  userId: ID2("Point Of Contact").required(
    "Please select a valid point of contact (user)"
  ),
})
